
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M1 25.2h30c.4 0 .8-.3.8-.8s-.3-.8-.8-.8h-1.8V5.4c0-.9-.7-1.6-1.6-1.6h-2.2c-.9 0-1.6.7-1.6 1.6v18.3h-1.6v-12c0-.9-.7-1.6-1.6-1.6h-2.2c-.9 0-1.6.7-1.6 1.6v12h-1.6V9.6c0-.9-.7-1.6-1.6-1.6h-2.2c-.7 0-1.4.7-1.4 1.6v14.1H8.4V13.3c0-.9-.7-1.6-1.6-1.6H4.7c-.9 0-1.6.7-1.6 1.6v10.4H1c-.4 0-.8.3-.8.8s.4.7.8.7zM25.3 5.4c0-.1.1-.1 0 0l2.2-.1s.1 0 .1.1v18.2h-2.3V5.4zm-6.9 6.3s.1 0 0 0l2.2-.1s.1 0 .1.1v11.8h-2.3V11.7zm-6.9-2.1s.1-.1 0 0l2.2-.1s.1 0 .1.1v13.9h-2.3V9.6zm-6.9 3.7s.1 0 0 0l2.2-.1s.1 0 .1.1v10.2H4.6V13.3zM31 26.7H1c-.4 0-.8.3-.8.8s.3.8.8.8h30c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z"}})])
          )
        }
      }
    